// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f8e938d7","703":"48ad6ace"}[chunkId] + ".chunk.js";
};